import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import types from './actionTypes';

/**
 * Contains the action creator functions that update the 'UAUserPreferences'
 * slice of the store.
 * @namespace UserPreferencesActions
 */
var actions = /*#__PURE__*/function () {
  function actions() {
    _classCallCheck(this, actions);
  }
  _createClass(actions, null, [{
    key: "changeLanguage",
    value:
    /**
     * Change the preferred language to the given language
     * @param {function} dispatch
     *
     * @function
     * @memberof UserPreferencesActions
     */
    function changeLanguage(dispatch, selectedLanguage) {
      dispatch({
        type: types.CHANGE_LANGUAGE,
        selectedLanguage: selectedLanguage
      });
    }
  }]);
  return actions;
}();
export { actions as default };